import type { IconSvgObject } from './types';

const CircleChevronLeftIcon: IconSvgObject = [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.75 8L11.2261 10.5858C10.5754 11.2525 10.25 11.5858 10.25 12C10.25 12.4142 10.5754 12.7475 11.2261 13.4142L13.75 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleChevronLeftIcon;
